export const ROUTES = {
  root: "/",
};
